export const ROUTES = {
  root: "/",
};
